export default __webpack_public_path__ + "static/media/paper-and-pen.7ec72810.svg";